import classnames from 'classnames';
import React from 'react';

import { Tooltip } from 'src/components/common/tooltip/Tooltip';

// A Tooltip component that displays when the value is truncated
export const TruncateWithTooltip = ({
  className,
  content,
}: {
  className?: string;
  content: string;
}) => {
  const [showTooltip, setShowTooltip] = React.useState(false);
  return (
    <Tooltip
      className="max-w-120 break-all"
      disabled={!showTooltip}
      label={content}
    >
      <div
        className={classnames(className, 'truncate')}
        title={!showTooltip ? content : undefined}
        ref={(element) => {
          setShowTooltip(
            element !== null && element.scrollWidth > element.clientWidth,
          );
        }}
      >
        {content}
      </div>
    </Tooltip>
  );
};
